import type { Theme, Components } from "@mui/material/styles";

import { inputLabelClasses } from "@mui/material/InputLabel";

import { fieldErrorInSx } from "../../keyframes";

// ----------------------------------------------------------------------

const INPUT_ERROR_BORDER = "#E53E3E";

// ----------------------------------------------------------------------

const MuiFormLabel: Components<Theme>["MuiFormLabel"] = {
  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    root: ({ theme }) => ({
      ...theme.typography.body2,
      color: theme.vars.palette.text.disabled,
      [`&.${inputLabelClasses.shrink}`]: {
        ...theme.typography.body1,
        fontWeight: 600,
        color: theme.vars.palette.text.secondary,
        [`&.${inputLabelClasses.focused}`]: { color: theme.vars.palette.text.primary },
        [`&.${inputLabelClasses.error}`]: { color: INPUT_ERROR_BORDER },
        [`&.${inputLabelClasses.disabled}`]: { color: theme.vars.palette.text.disabled },
        [`&.${inputLabelClasses.filled}`]: { transform: "translate(14px, -9px) scale(0.75)" },
      },
    }),
  },
};

// ----------------------------------------------------------------------

const MuiFormHelperText: Components<Theme>["MuiFormHelperText"] = {
  /** **************************************
   * DEFAULT PROPS
   *************************************** */
  defaultProps: { component: "div" },

  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      marginTop: theme.spacing(1),
      ...(ownerState?.error && {
        color: theme.vars.palette.error.main,
        ...fieldErrorInSx,
      }),
    }),
  },
};

// ----------------------------------------------------------------------

const MuiFormControlLabel: Components<Theme>["MuiFormControlLabel"] = {
  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: { label: ({ theme }) => ({ ...theme.typography.body2 }) },
};

// ----------------------------------------------------------------------

export const form = { MuiFormLabel, MuiFormHelperText, MuiFormControlLabel };
